import { ResourceTypeLink } from "@evergis/api";
import { useCallback } from "react";
import { setLayerPreview, setProjectPreview, setTablePreview } from "../../resources/preview";
import { usePreviewUrl } from "./usePreviewUrl";

type PreviewMutation = typeof setProjectPreview | typeof setLayerPreview | typeof setTablePreview;

const usePreview = (
  resourceType: ResourceTypeLink,
  resourceName: string,
  previewMutation: PreviewMutation,
): [string, (name: string, preview: File) => Promise<void>] => {
  const previewUrl = usePreviewUrl(resourceType, resourceName);
  const [setPreview] = previewMutation.use();

  const uploadPreview = useCallback(
    (name: string, preview: File) => setPreview({ input: { name, preview } }),
    [setPreview],
  );

  return [previewUrl, uploadPreview];
};

export const useProjectPreview = (resourceName?: string) =>
  usePreview(ResourceTypeLink.Project, resourceName, setProjectPreview);

export const useLayerPreview = (resourceName?: string) =>
  usePreview(ResourceTypeLink.Layer, resourceName, setLayerPreview);

export const useTablePreview = (resourceName?: string) =>
  usePreview(ResourceTypeLink.Table, resourceName, setTablePreview);
